import { action } from 'typesafe-actions';
import { IInvite, IInviteVerify } from 'types';
import { Invites } from './types';

export const verifyInviteRequest = (inviteId: string) => action(Invites.VERIFY_INVITE_REQUEST, { inviteId });
export const verifyInviteSuccess = (response: IInviteVerify) => action(Invites.VERIFY_INVITE_SUCCESS, response);
export const verifyInviteFail = (error: any, failToast?: boolean) => action(Invites.VERIFY_INVITE_FAIL, error, { failToast });

export const getInviteRequest = (inviteId: string, onSuccess?: () => void) => action(Invites.GET_INVITE_REQUEST, { inviteId, onSuccess });
export const getInviteSuccess = (response: IInvite) => action(Invites.GET_INVITE_SUCCESS, response);
export const getInviteFail = (error: any) => action(Invites.GET_INVITE_FAIL, error);

export const acceptInviteRequest = (inviteId: string, onSuccess?: (inviteResponse: IInvite) => void) => action(Invites.ACCEPT_INVITE_REQUEST, { inviteId, onSuccess });
export const acceptInviteSuccess = (response: IInvite) => action(Invites.ACCEPT_INVITE_SUCCESS, response);
export const acceptInviteFail = (error: any) => action(Invites.ACCEPT_INVITE_FAIL, error);

export const clearInvite = () => action(Invites.CLEAR_INVITE);
